// // ============================================================
// // src/components/admin/DoctorAccountTab.js
// // ✅ Uses hospitalId from JWT token to isolate doctor accounts
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";

// const INP = {
//   width: "100%",
//   padding: "10px 12px",
//   borderRadius: 8,
//   border: "1px solid #d1d5db",
//   fontSize: 13,
//   outline: "none",
//   boxSizing: "border-box",
//   fontFamily: "'DM Sans',sans-serif",
//   background: "#fff",
// };
// const LBL = {
//   display: "block",
//   fontSize: 11,
//   fontWeight: 700,
//   color: "#64748b",
//   textTransform: "uppercase",
//   letterSpacing: "0.5px",
//   marginBottom: 5,
// };
// const BTN_PRIMARY = {
//   padding: "11px 24px",
//   borderRadius: 8,
//   border: "none",
//   background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//   color: "#fff",
//   fontWeight: 700,
//   fontSize: 13,
//   cursor: "pointer",
//   fontFamily: "'DM Sans',sans-serif",
//   width: "100%",
// };
// const BTN_GHOST = {
//   padding: "11px 18px",
//   borderRadius: 8,
//   border: "1px solid #d1d5db",
//   background: "#f8fafc",
//   color: "#374151",
//   fontWeight: 600,
//   fontSize: 13,
//   cursor: "pointer",
//   fontFamily: "'DM Sans',sans-serif",
//   width: "100%",
// };

// const SPECIALTIES = [
//   "Chief Dental Surgeon",
//   "Cosmetic & Aesthetic Dentist",
//   "Orthodontics & Invisalign",
//   "Root Canal Specialist",
//   "Pediatric Dentist",
//   "Oral & Maxillofacial Surgeon",
//   "Periodontics Specialist",
//   "Prosthodontics",
//   "General Dentistry",
//   "Dental Implant Specialist",
//   "Other",
// ];

// // ✅ Get hospitalId from current JWT token
// function getHospitalIdFromToken() {
//   try {
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;
//     const key = slug
//       ? `pearlsmile_token_${slug}`
//       : "pearlsmile_token_pearlsmile";
//     const token = localStorage.getItem(key);
//     if (!token) return null;
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     return payload?.hospitalId || null;
//   } catch {
//     return null;
//   }
// }

// function passwordStrength(pw) {
//   if (!pw) return { score: 0, label: "", color: "#e5e7eb" };
//   let score = 0;
//   if (pw.length >= 8) score++;
//   if (/[A-Z]/.test(pw)) score++;
//   if (/[0-9]/.test(pw)) score++;
//   if (/[^A-Za-z0-9]/.test(pw)) score++;
//   if (pw.length >= 12) score++;
//   const map = [
//     { label: "Very Weak", color: "#ef4444" },
//     { label: "Weak", color: "#f97316" },
//     { label: "Fair", color: "#eab308" },
//     { label: "Good", color: "#22c55e" },
//     { label: "Strong", color: "#16a34a" },
//   ];
//   return { score, ...map[Math.min(score, 4)] };
// }

// function DoctorCard({ doc, onDelete, currentDoctorId }) {
//   const isMe = doc.doctorId === currentDoctorId;
//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 14,
//         padding: "14px 16px",
//         display: "flex",
//         gap: 12,
//         alignItems: "flex-start",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         borderLeft: isMe ? "4px solid #0d7377" : "1px solid #e5e7eb",
//       }}
//     >
//       <div
//         style={{
//           width: 46,
//           height: 46,
//           borderRadius: "50%",
//           flexShrink: 0,
//           background: isMe
//             ? "linear-gradient(135deg,#0d7377,#14a0a5)"
//             : "linear-gradient(135deg,#1e40af,#3b82f6)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: 20,
//           color: "#fff",
//           fontWeight: 700,
//         }}
//       >
//         {(doc.name || "?")
//           .replace(/^Dr\.\s*/i, "")
//           .charAt(0)
//           .toUpperCase()}
//       </div>
//       <div style={{ flex: 1, minWidth: 0 }}>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 6,
//             flexWrap: "wrap",
//           }}
//         >
//           <div style={{ fontWeight: 700, fontSize: 14, color: "#0a1628" }}>
//             {doc.name}
//           </div>
//           {isMe && (
//             <span
//               style={{
//                 background: "rgba(13,115,119,0.12)",
//                 border: "1px solid rgba(13,115,119,0.3)",
//                 color: "#0d7377",
//                 borderRadius: 20,
//                 fontSize: 10,
//                 fontWeight: 800,
//                 padding: "2px 8px",
//                 letterSpacing: "0.5px",
//               }}
//             >
//               YOU
//             </span>
//           )}
//         </div>
//         <div
//           style={{
//             fontSize: 12,
//             color: "#0d7377",
//             fontWeight: 600,
//             marginTop: 2,
//           }}
//         >
//           {doc.specialty || "—"}
//         </div>
//         <div
//           style={{
//             marginTop: 6,
//             display: "flex",
//             gap: 8,
//             flexWrap: "wrap",
//             alignItems: "center",
//           }}
//         >
//           <span
//             style={{
//               background: "#f1f5f9",
//               border: "1px solid #e2e8f0",
//               borderRadius: 6,
//               fontSize: 11,
//               padding: "3px 8px",
//               color: "#475569",
//               fontWeight: 600,
//               fontFamily: "monospace",
//             }}
//           >
//             ID: {doc.doctorId}
//           </span>
//           {doc.createdAt && (
//             <span style={{ fontSize: 11, color: "#94a3b8" }}>
//               Joined{" "}
//               {new Date(doc.createdAt).toLocaleDateString("en-IN", {
//                 day: "numeric",
//                 month: "short",
//                 year: "numeric",
//               })}
//             </span>
//           )}
//         </div>
//       </div>
//       {!isMe && (
//         <button
//           onClick={() => onDelete(doc)}
//           style={{
//             padding: "6px 12px",
//             borderRadius: 7,
//             border: "1px solid #fca5a5",
//             background: "#fef2f2",
//             color: "#dc2626",
//             fontSize: 11,
//             fontWeight: 700,
//             cursor: "pointer",
//             flexShrink: 0,
//             whiteSpace: "nowrap",
//           }}
//         >
//           Delete
//         </button>
//       )}
//     </div>
//   );
// }

// function CreateAccountForm({ onCreated, showNotify }) {
//   const [form, setForm] = useState({
//     name: "",
//     specialty: "",
//     doctorId: "",
//     password: "",
//     confirmPw: "",
//   });
//   const [saving, setSaving] = useState(false);
//   const [showPw, setShowPw] = useState(false);
//   const [showCpw, setShowCpw] = useState(false);
//   const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const strength = passwordStrength(form.password);

//   const handleCreate = async () => {
//     if (!form.name.trim()) {
//       showNotify("Error", "Full name is required.", true);
//       return;
//     }
//     if (!form.specialty) {
//       showNotify("Error", "Please select a specialty.", true);
//       return;
//     }
//     if (!form.doctorId.trim()) {
//       showNotify("Error", "Doctor ID is required.", true);
//       return;
//     }
//     if (form.doctorId.includes(" ")) {
//       showNotify("Error", "Doctor ID cannot contain spaces.", true);
//       return;
//     }
//     if (!form.password) {
//       showNotify("Error", "Password is required.", true);
//       return;
//     }
//     if (form.password.length < 6) {
//       showNotify("Error", "Password must be at least 6 characters.", true);
//       return;
//     }
//     if (form.password !== form.confirmPw) {
//       showNotify("Error", "Passwords do not match.", true);
//       return;
//     }
//     setSaving(true);
//     try {
//       // ✅ api.post sends JWT token → backend reads hospitalId from token
//       await api.post("/auth/register", {
//         name: form.name.trim(),
//         specialty: form.specialty,
//         doctorId: form.doctorId.trim().toLowerCase(),
//         password: form.password,
//       });
//       showNotify(
//         "Account Created! ✓",
//         `Dr. ${form.name} can now log in with ID: ${form.doctorId.toLowerCase()}`,
//       );
//       setForm({
//         name: "",
//         specialty: "",
//         doctorId: "",
//         password: "",
//         confirmPw: "",
//       });
//       onCreated();
//     } catch (err) {
//       showNotify("Error", err.message || "Failed to create account.", true);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 16,
//         padding: "20px",
//         boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
//       }}
//     >
//       <div
//         style={{
//           fontSize: 14,
//           fontWeight: 800,
//           color: "#0a1628",
//           marginBottom: 16,
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//           flexWrap: "wrap",
//         }}
//       >
//         <span
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             color: "#fff",
//             borderRadius: 8,
//             padding: "6px 10px",
//             fontSize: 16,
//           }}
//         >
//           🩺
//         </span>
//         Create New Doctor Account
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//         <div>
//           <label style={LBL}>Full Name *</label>
//           <input
//             value={form.name}
//             onChange={(e) => sf("name", e.target.value)}
//             placeholder="e.g. Dr. Neha Joshi"
//             style={INP}
//           />
//         </div>
//         <div>
//           <label style={LBL}>Specialty *</label>
//           <select
//             value={form.specialty}
//             onChange={(e) => sf("specialty", e.target.value)}
//             style={INP}
//           >
//             <option value="">— Select Specialty —</option>
//             {SPECIALTIES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <label style={LBL}>Doctor ID (Login Username) *</label>
//           <input
//             value={form.doctorId}
//             onChange={(e) => sf("doctorId", e.target.value.replace(/\s/g, ""))}
//             placeholder="e.g. drneha"
//             style={{ ...INP, fontFamily: "monospace", letterSpacing: "0.5px" }}
//           />
//           <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4 }}>
//             No spaces. Doctor types this at login screen.
//           </div>
//         </div>
//         <div>
//           <label style={LBL}>Password *</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showPw ? "text" : "password"}
//               value={form.password}
//               onChange={(e) => sf("password", e.target.value)}
//               placeholder="Min. 6 characters"
//               style={{ ...INP, paddingRight: 40 }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowPw((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showPw ? "🙈" : "👁️"}
//             </button>
//           </div>
//           {form.password && (
//             <div style={{ marginTop: 6 }}>
//               <div
//                 style={{
//                   height: 4,
//                   borderRadius: 2,
//                   background: "#e5e7eb",
//                   overflow: "hidden",
//                 }}
//               >
//                 <div
//                   style={{
//                     height: "100%",
//                     borderRadius: 2,
//                     width: `${(strength.score / 4) * 100}%`,
//                     background: strength.color,
//                     transition: "width 0.3s ease",
//                   }}
//                 />
//               </div>
//               <div
//                 style={{
//                   fontSize: 10,
//                   color: strength.color,
//                   fontWeight: 700,
//                   marginTop: 3,
//                 }}
//               >
//                 {strength.label}
//               </div>
//             </div>
//           )}
//         </div>
//         <div>
//           <label style={LBL}>Confirm Password *</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showCpw ? "text" : "password"}
//               value={form.confirmPw}
//               onChange={(e) => sf("confirmPw", e.target.value)}
//               placeholder="Re-enter password"
//               style={{
//                 ...INP,
//                 paddingRight: 40,
//                 borderColor:
//                   form.confirmPw && form.password !== form.confirmPw
//                     ? "#ef4444"
//                     : form.confirmPw && form.password === form.confirmPw
//                       ? "#22c55e"
//                       : "#d1d5db",
//               }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowCpw((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showCpw ? "🙈" : "👁️"}
//             </button>
//           </div>
//           {form.confirmPw && (
//             <div
//               style={{
//                 fontSize: 10,
//                 marginTop: 3,
//                 fontWeight: 700,
//                 color: form.password === form.confirmPw ? "#22c55e" : "#ef4444",
//               }}
//             >
//               {form.password === form.confirmPw
//                 ? "✓ Passwords match"
//                 : "✗ Passwords do not match"}
//             </div>
//           )}
//         </div>
//         <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//           <div style={{ flex: "1 1 140px" }}>
//             <button
//               onClick={handleCreate}
//               disabled={saving}
//               style={{ ...BTN_PRIMARY, opacity: saving ? 0.7 : 1 }}
//             >
//               {saving ? "Creating..." : "🔐 Create Account"}
//             </button>
//           </div>
//           <div style={{ flex: "1 1 100px" }}>
//             <button
//               onClick={() =>
//                 setForm({
//                   name: "",
//                   specialty: "",
//                   doctorId: "",
//                   password: "",
//                   confirmPw: "",
//                 })
//               }
//               style={BTN_GHOST}
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ChangePasswordForm({ currentDoctor, showNotify }) {
//   const [form, setForm] = useState({ oldPw: "", newPw: "", confirmPw: "" });
//   const [saving, setSaving] = useState(false);
//   const [showOld, setShowOld] = useState(false);
//   const [showNew, setShowNew] = useState(false);
//   const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const strength = passwordStrength(form.newPw);

//   const handleChange = async () => {
//     if (!form.oldPw) {
//       showNotify("Error", "Enter your current password.", true);
//       return;
//     }
//     if (!form.newPw) {
//       showNotify("Error", "Enter a new password.", true);
//       return;
//     }
//     if (form.newPw.length < 6) {
//       showNotify("Error", "New password must be at least 6 characters.", true);
//       return;
//     }
//     if (form.newPw !== form.confirmPw) {
//       showNotify("Error", "New passwords do not match.", true);
//       return;
//     }
//     if (form.oldPw === form.newPw) {
//       showNotify("Error", "New password must be different.", true);
//       return;
//     }
//     setSaving(true);
//     try {
//       await api.post("/auth/change-password", {
//         oldPassword: form.oldPw,
//         newPassword: form.newPw,
//       });
//       showNotify(
//         "Password Changed! ✓",
//         "Your new password is active. Use it next time you log in.",
//       );
//       setForm({ oldPw: "", newPw: "", confirmPw: "" });
//     } catch (err) {
//       showNotify("Error", err.message || "Failed to change password.", true);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 16,
//         padding: "20px",
//         boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
//       }}
//     >
//       <div
//         style={{
//           fontSize: 14,
//           fontWeight: 800,
//           color: "#0a1628",
//           marginBottom: 4,
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//         }}
//       >
//         <span
//           style={{
//             background: "linear-gradient(135deg,#c9a84c,#d4af37)",
//             color: "#fff",
//             borderRadius: 8,
//             padding: "6px 10px",
//             fontSize: 16,
//           }}
//         >
//           🔑
//         </span>
//         Change My Password
//       </div>
//       <div
//         style={{
//           fontSize: 11,
//           color: "#64748b",
//           fontWeight: 500,
//           background: "#f1f5f9",
//           border: "1px solid #e2e8f0",
//           borderRadius: 8,
//           padding: "6px 12px",
//           marginBottom: 16,
//           display: "inline-block",
//         }}
//       >
//         Logged in as: <strong>{currentDoctor?.name}</strong>
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//         <div>
//           <label style={LBL}>Current Password</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showOld ? "text" : "password"}
//               value={form.oldPw}
//               onChange={(e) => sf("oldPw", e.target.value)}
//               placeholder="Your current password"
//               style={{ ...INP, paddingRight: 40 }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowOld((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showOld ? "🙈" : "👁️"}
//             </button>
//           </div>
//         </div>
//         <div>
//           <label style={LBL}>New Password</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showNew ? "text" : "password"}
//               value={form.newPw}
//               onChange={(e) => sf("newPw", e.target.value)}
//               placeholder="Min. 6 characters"
//               style={{ ...INP, paddingRight: 40 }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowNew((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showNew ? "🙈" : "👁️"}
//             </button>
//           </div>
//           {form.newPw && (
//             <div style={{ marginTop: 4 }}>
//               <div
//                 style={{
//                   height: 3,
//                   borderRadius: 2,
//                   background: "#e5e7eb",
//                   overflow: "hidden",
//                 }}
//               >
//                 <div
//                   style={{
//                     height: "100%",
//                     borderRadius: 2,
//                     width: `${(strength.score / 4) * 100}%`,
//                     background: strength.color,
//                   }}
//                 />
//               </div>
//               <div
//                 style={{
//                   fontSize: 10,
//                   color: strength.color,
//                   fontWeight: 700,
//                   marginTop: 2,
//                 }}
//               >
//                 {strength.label}
//               </div>
//             </div>
//           )}
//         </div>
//         <div>
//           <label style={LBL}>Confirm New Password</label>
//           <input
//             type="password"
//             value={form.confirmPw}
//             onChange={(e) => sf("confirmPw", e.target.value)}
//             placeholder="Re-enter new password"
//             style={{
//               ...INP,
//               borderColor:
//                 form.confirmPw && form.newPw !== form.confirmPw
//                   ? "#ef4444"
//                   : form.confirmPw && form.newPw === form.confirmPw
//                     ? "#22c55e"
//                     : "#d1d5db",
//             }}
//           />
//           {form.confirmPw && (
//             <div
//               style={{
//                 fontSize: 10,
//                 marginTop: 3,
//                 fontWeight: 700,
//                 color: form.newPw === form.confirmPw ? "#22c55e" : "#ef4444",
//               }}
//             >
//               {form.newPw === form.confirmPw ? "✓ Match" : "✗ No match"}
//             </div>
//           )}
//         </div>
//         <button
//           onClick={handleChange}
//           disabled={saving}
//           style={{
//             ...BTN_PRIMARY,
//             background: "linear-gradient(135deg,#92400e,#c9a84c)",
//             opacity: saving ? 0.7 : 1,
//           }}
//         >
//           {saving ? "Saving..." : "🔑 Update Password"}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default function DoctorAccountTab({ showNotify, doctor }) {
//   const [doctors, setDoctors] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       // ✅ Get hospitalId from JWT token in localStorage
//       const hospitalId = getHospitalIdFromToken();
//       // ✅ Pass hospitalId as query param for isolation
//       const url = hospitalId
//         ? `/auth/doctors?hospitalId=${hospitalId}`
//         : `/auth/doctors`;
//       const data = await api.get(url);
//       const filtered = Array.isArray(data)
//         ? data.filter((d) => !d.isAdmin)
//         : [];
//       setDoctors(filtered);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, [showNotify]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const handleDelete = async (doc) => {
//     if (
//       !window.confirm(
//         `Delete account for ${doc.name}?\n\nThey will no longer be able to log in.`,
//       )
//     )
//       return;
//     try {
//       await api.delete("/auth/doctors/" + doc._id);
//       showNotify("Deleted", `${doc.name}'s account removed.`);
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   return (
//     <div style={{ paddingBottom: 48 }}>
//       <style>{`
//         .da-outer-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; align-items: start; }
//         .da-steps-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
//         @media (max-width: 768px) {
//           .da-outer-grid { grid-template-columns: 1fr !important; }
//           .da-steps-grid { grid-template-columns: 1fr !important; }
//         }
//       `}</style>
//       <div className="admin-section-title">Doctor Accounts</div>
//       <div className="admin-section-desc" style={{ marginBottom: 20 }}>
//         Each doctor can create their own login account here. Once created, they
//         can log in using their <strong>Doctor ID + Password</strong>.
//       </div>
//       <div
//         style={{
//           background:
//             "linear-gradient(135deg,rgba(10,22,40,0.04),rgba(13,115,119,0.06))",
//           border: "1px solid rgba(13,115,119,0.2)",
//           borderRadius: 12,
//           padding: "14px 16px",
//           marginBottom: 20,
//         }}
//       >
//         <div className="da-steps-grid">
//           {[
//             {
//               icon: "1️⃣",
//               text: "Doctor fills in their name, specialty, Doctor ID and password below",
//             },
//             {
//               icon: "2️⃣",
//               text: 'Click "Create Account" — saved instantly to database',
//             },
//             {
//               icon: "3️⃣",
//               text: "Doctor goes to login screen → types their Doctor ID + password → access granted",
//             },
//             {
//               icon: "4️⃣",
//               text: "Their name now appears on all visits, bills, prescriptions automatically",
//             },
//           ].map((s) => (
//             <div
//               key={s.icon}
//               style={{ display: "flex", gap: 8, alignItems: "flex-start" }}
//             >
//               <span style={{ fontSize: 18, flexShrink: 0 }}>{s.icon}</span>
//               <span style={{ fontSize: 12, color: "#475569", lineHeight: 1.5 }}>
//                 {s.text}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="da-outer-grid">
//         <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
//           <CreateAccountForm onCreated={load} showNotify={showNotify} />
//           <ChangePasswordForm currentDoctor={doctor} showNotify={showNotify} />
//         </div>
//         <div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 8,
//             }}
//           >
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#1e293b",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//               }}
//             >
//               <span
//                 style={{
//                   background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                   color: "#fff",
//                   borderRadius: 8,
//                   padding: "4px 10px",
//                   fontSize: 13,
//                   fontWeight: 800,
//                 }}
//               >
//                 {loading ? "..." : doctors.length}
//               </span>
//               Doctor{doctors.length !== 1 ? "s" : ""} in system
//             </div>
//             <button
//               onClick={load}
//               style={{
//                 padding: "7px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 background: "#f8fafc",
//                 color: "#374151",
//                 fontWeight: 600,
//                 fontSize: 12,
//                 cursor: "pointer",
//               }}
//             >
//               🔄 Refresh
//             </button>
//           </div>
//           {loading ? (
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: 32,
//                 color: "#94a3b8",
//                 fontSize: 13,
//               }}
//             >
//               Loading accounts...
//             </div>
//           ) : doctors.length === 0 ? (
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: 40,
//                 background: "#f8fafc",
//                 borderRadius: 14,
//                 color: "#94a3b8",
//                 fontSize: 13,
//                 border: "1px dashed #e2e8f0",
//               }}
//             >
//               No doctor accounts yet.
//               <br />
//               Create the first one using the form.
//             </div>
//           ) : (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {doctors.map((doc) => (
//                 <DoctorCard
//                   key={doc._id}
//                   doc={doc}
//                   onDelete={handleDelete}
//                   currentDoctorId={doctor?.doctorId}
//                 />
//               ))}
//             </div>
//           )}
//           {doctors.length > 0 && (
//             <div
//               style={{
//                 marginTop: 16,
//                 background: "rgba(234,179,8,0.07)",
//                 border: "1px solid rgba(234,179,8,0.3)",
//                 borderRadius: 10,
//                 padding: "12px 14px",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 11,
//                   color: "#92400e",
//                   fontWeight: 700,
//                   marginBottom: 4,
//                 }}
//               >
//                 🔒 Security Reminder
//               </div>
//               <div style={{ fontSize: 11, color: "#78350f", lineHeight: 1.7 }}>
//                 • Each doctor should keep their password private.
//                 <br />
//                 • To reset a doctor's password, delete their account and create
//                 a new one.
//                 <br />• You cannot see saved passwords — only the doctor knows
//                 theirs.
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

/////////////// above correct //////////////////

// // ============================================================
// // src/components/admin/DoctorAccountTab.js
// // ✅ Uses hospitalId from JWT token to isolate doctor accounts
// // ✅ Plan-based doctor limit (starter=3, pro=10, enterprise=unlimited)
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// const INP = {
//   width: "100%",
//   padding: "10px 12px",
//   borderRadius: 8,
//   border: "1px solid #d1d5db",
//   fontSize: 13,
//   outline: "none",
//   boxSizing: "border-box",
//   fontFamily: "'DM Sans',sans-serif",
//   background: "#fff",
// };
// const LBL = {
//   display: "block",
//   fontSize: 11,
//   fontWeight: 700,
//   color: "#64748b",
//   textTransform: "uppercase",
//   letterSpacing: "0.5px",
//   marginBottom: 5,
// };
// const BTN_PRIMARY = {
//   padding: "11px 24px",
//   borderRadius: 8,
//   border: "none",
//   background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//   color: "#fff",
//   fontWeight: 700,
//   fontSize: 13,
//   cursor: "pointer",
//   fontFamily: "'DM Sans',sans-serif",
//   width: "100%",
// };
// const BTN_GHOST = {
//   padding: "11px 18px",
//   borderRadius: 8,
//   border: "1px solid #d1d5db",
//   background: "#f8fafc",
//   color: "#374151",
//   fontWeight: 600,
//   fontSize: 13,
//   cursor: "pointer",
//   fontFamily: "'DM Sans',sans-serif",
//   width: "100%",
// };

// // ✅ Plan limits
// const PLAN_LIMITS = {
//   starter: 3,
//   pro: 10,
//   enterprise: Infinity,
// };

// // ✅ Plan display names
// const PLAN_NAMES = {
//   starter: "Starter",
//   pro: "Pro",
//   enterprise: "Enterprise",
// };

// // ✅ Upgrade plan suggestion
// const UPGRADE_PLAN = {
//   starter: "Pro (₹1,999/month) — up to 10 doctors",
//   pro: "Enterprise (₹3,499/month) — unlimited doctors",
//   enterprise: null,
// };

// const SPECIALTIES = [
//   "Chief Dental Surgeon",
//   "Cosmetic & Aesthetic Dentist",
//   "Orthodontics & Invisalign",
//   "Root Canal Specialist",
//   "Pediatric Dentist",
//   "Oral & Maxillofacial Surgeon",
//   "Periodontics Specialist",
//   "Prosthodontics",
//   "General Dentistry",
//   "Dental Implant Specialist",
//   "Other",
// ];

// // ✅ Get hospitalId from current JWT token
// function getHospitalIdFromToken() {
//   try {
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;
//     const key = slug
//       ? `pearlsmile_token_${slug}`
//       : "pearlsmile_token_pearlsmile";
//     const token = localStorage.getItem(key);
//     if (!token) return null;
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     return payload?.hospitalId || null;
//   } catch {
//     return null;
//   }
// }

// function passwordStrength(pw) {
//   if (!pw) return { score: 0, label: "", color: "#e5e7eb" };
//   let score = 0;
//   if (pw.length >= 8) score++;
//   if (/[A-Z]/.test(pw)) score++;
//   if (/[0-9]/.test(pw)) score++;
//   if (/[^A-Za-z0-9]/.test(pw)) score++;
//   if (pw.length >= 12) score++;
//   const map = [
//     { label: "Very Weak", color: "#ef4444" },
//     { label: "Weak", color: "#f97316" },
//     { label: "Fair", color: "#eab308" },
//     { label: "Good", color: "#22c55e" },
//     { label: "Strong", color: "#16a34a" },
//   ];
//   return { score, ...map[Math.min(score, 4)] };
// }

// function DoctorCard({ doc, onDelete, currentDoctorId }) {
//   const isMe = doc.doctorId === currentDoctorId;
//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 14,
//         padding: "14px 16px",
//         display: "flex",
//         gap: 12,
//         alignItems: "flex-start",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         borderLeft: isMe ? "4px solid #0d7377" : "1px solid #e5e7eb",
//       }}
//     >
//       <div
//         style={{
//           width: 46,
//           height: 46,
//           borderRadius: "50%",
//           flexShrink: 0,
//           background: isMe
//             ? "linear-gradient(135deg,#0d7377,#14a0a5)"
//             : "linear-gradient(135deg,#1e40af,#3b82f6)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: 20,
//           color: "#fff",
//           fontWeight: 700,
//         }}
//       >
//         {(doc.name || "?")
//           .replace(/^Dr\.\s*/i, "")
//           .charAt(0)
//           .toUpperCase()}
//       </div>
//       <div style={{ flex: 1, minWidth: 0 }}>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 6,
//             flexWrap: "wrap",
//           }}
//         >
//           <div style={{ fontWeight: 700, fontSize: 14, color: "#0a1628" }}>
//             {doc.name}
//           </div>
//           {isMe && (
//             <span
//               style={{
//                 background: "rgba(13,115,119,0.12)",
//                 border: "1px solid rgba(13,115,119,0.3)",
//                 color: "#0d7377",
//                 borderRadius: 20,
//                 fontSize: 10,
//                 fontWeight: 800,
//                 padding: "2px 8px",
//                 letterSpacing: "0.5px",
//               }}
//             >
//               YOU
//             </span>
//           )}
//         </div>
//         <div
//           style={{
//             fontSize: 12,
//             color: "#0d7377",
//             fontWeight: 600,
//             marginTop: 2,
//           }}
//         >
//           {doc.specialty || "—"}
//         </div>
//         <div
//           style={{
//             marginTop: 6,
//             display: "flex",
//             gap: 8,
//             flexWrap: "wrap",
//             alignItems: "center",
//           }}
//         >
//           <span
//             style={{
//               background: "#f1f5f9",
//               border: "1px solid #e2e8f0",
//               borderRadius: 6,
//               fontSize: 11,
//               padding: "3px 8px",
//               color: "#475569",
//               fontWeight: 600,
//               fontFamily: "monospace",
//             }}
//           >
//             ID: {doc.doctorId}
//           </span>
//           {doc.createdAt && (
//             <span style={{ fontSize: 11, color: "#94a3b8" }}>
//               Joined{" "}
//               {new Date(doc.createdAt).toLocaleDateString("en-IN", {
//                 day: "numeric",
//                 month: "short",
//                 year: "numeric",
//               })}
//             </span>
//           )}
//         </div>
//       </div>
//       {!isMe && (
//         <button
//           onClick={() => onDelete(doc)}
//           style={{
//             padding: "6px 12px",
//             borderRadius: 7,
//             border: "1px solid #fca5a5",
//             background: "#fef2f2",
//             color: "#dc2626",
//             fontSize: 11,
//             fontWeight: 700,
//             cursor: "pointer",
//             flexShrink: 0,
//             whiteSpace: "nowrap",
//           }}
//         >
//           Delete
//         </button>
//       )}
//     </div>
//   );
// }

// // ✅ Plan limit banner shown when limit is reached
// function PlanLimitBanner({ planName, limit, upgradeTo }) {
//   return (
//     <div
//       style={{
//         background: "linear-gradient(135deg,#fef3c7,#fde68a)",
//         border: "1.5px solid #f59e0b",
//         borderRadius: 14,
//         padding: "16px 18px",
//         marginBottom: 16,
//       }}
//     >
//       <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
//         <span style={{ fontSize: 28, flexShrink: 0 }}>🚫</span>
//         <div>
//           <div
//             style={{
//               fontWeight: 800,
//               fontSize: 14,
//               color: "#92400e",
//               marginBottom: 4,
//             }}
//           >
//             Doctor Limit Reached — {PLAN_NAMES[planName] || planName} Plan
//           </div>
//           <div
//             style={{
//               fontSize: 13,
//               color: "#78350f",
//               lineHeight: 1.6,
//               marginBottom: 8,
//             }}
//           >
//             Your <strong>{PLAN_NAMES[planName] || planName}</strong> plan allows
//             a maximum of{" "}
//             <strong>
//               {limit} doctor{limit !== 1 ? "s" : ""}
//             </strong>
//             . You have already reached this limit and cannot add more doctors.
//           </div>
//           {upgradeTo && (
//             <div
//               style={{
//                 background: "rgba(255,255,255,0.7)",
//                 border: "1px solid rgba(245,158,11,0.4)",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 fontSize: 12,
//                 color: "#92400e",
//               }}
//             >
//               <span style={{ fontWeight: 700 }}>💡 Upgrade to </span>
//               {upgradeTo}
//               <br />
//               <span style={{ color: "#78350f" }}>
//                 Contact your admin or go to the <strong>💳 Subscription</strong>{" "}
//                 tab to upgrade your plan.
//               </span>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// function CreateAccountForm({
//   onCreated,
//   showNotify,
//   doctorCount,
//   planLimit,
//   planName,
// }) {
//   const [form, setForm] = useState({
//     name: "",
//     specialty: "",
//     doctorId: "",
//     password: "",
//     confirmPw: "",
//   });
//   const [saving, setSaving] = useState(false);
//   const [showPw, setShowPw] = useState(false);
//   const [showCpw, setShowCpw] = useState(false);
//   const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const strength = passwordStrength(form.password);

//   // ✅ Check if limit reached
//   const limitReached = planLimit !== Infinity && doctorCount >= planLimit;

//   const handleCreate = async () => {
//     // ✅ Plan limit check FIRST
//     if (limitReached) {
//       showNotify(
//         "Plan Limit Reached 🚫",
//         `Your ${PLAN_NAMES[planName] || planName} plan allows only ${planLimit} doctor${planLimit !== 1 ? "s" : ""}. Please upgrade your plan to add more doctors.`,
//         true,
//       );
//       return;
//     }
//     if (!form.name.trim()) {
//       showNotify("Error", "Full name is required.", true);
//       return;
//     }
//     if (!form.specialty) {
//       showNotify("Error", "Please select a specialty.", true);
//       return;
//     }
//     if (!form.doctorId.trim()) {
//       showNotify("Error", "Doctor ID is required.", true);
//       return;
//     }
//     if (form.doctorId.includes(" ")) {
//       showNotify("Error", "Doctor ID cannot contain spaces.", true);
//       return;
//     }
//     if (!form.password) {
//       showNotify("Error", "Password is required.", true);
//       return;
//     }
//     if (form.password.length < 6) {
//       showNotify("Error", "Password must be at least 6 characters.", true);
//       return;
//     }
//     if (form.password !== form.confirmPw) {
//       showNotify("Error", "Passwords do not match.", true);
//       return;
//     }
//     setSaving(true);
//     try {
//       await api.post("/auth/register", {
//         name: form.name.trim(),
//         specialty: form.specialty,
//         doctorId: form.doctorId.trim().toLowerCase(),
//         password: form.password,
//       });
//       showNotify(
//         "Account Created! ✓",
//         `Dr. ${form.name} can now log in with ID: ${form.doctorId.toLowerCase()}`,
//       );
//       setForm({
//         name: "",
//         specialty: "",
//         doctorId: "",
//         password: "",
//         confirmPw: "",
//       });
//       onCreated();
//     } catch (err) {
//       showNotify("Error", err.message || "Failed to create account.", true);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 16,
//         padding: "20px",
//         boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
//       }}
//     >
//       <div
//         style={{
//           fontSize: 14,
//           fontWeight: 800,
//           color: "#0a1628",
//           marginBottom: 16,
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//           flexWrap: "wrap",
//         }}
//       >
//         <span
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             color: "#fff",
//             borderRadius: 8,
//             padding: "6px 10px",
//             fontSize: 16,
//           }}
//         >
//           🩺
//         </span>
//         Create New Doctor Account
//         {/* ✅ Plan limit indicator */}
//         {planLimit !== Infinity && (
//           <span
//             style={{
//               marginLeft: "auto",
//               background: limitReached ? "#fef2f2" : "#f0fdf4",
//               border: `1px solid ${limitReached ? "#fca5a5" : "#bbf7d0"}`,
//               color: limitReached ? "#dc2626" : "#16a34a",
//               borderRadius: 20,
//               fontSize: 11,
//               fontWeight: 700,
//               padding: "3px 10px",
//             }}
//           >
//             {doctorCount} / {planLimit} doctors used
//           </span>
//         )}
//       </div>

//       {/* ✅ Show limit banner if reached */}
//       {limitReached && (
//         <PlanLimitBanner
//           planName={planName}
//           limit={planLimit}
//           upgradeTo={UPGRADE_PLAN[planName]}
//         />
//       )}

//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: 14,
//           opacity: limitReached ? 0.5 : 1,
//           pointerEvents: limitReached ? "none" : "auto",
//         }}
//       >
//         <div>
//           <label style={LBL}>Full Name *</label>
//           <input
//             value={form.name}
//             onChange={(e) => sf("name", e.target.value)}
//             placeholder="e.g. Dr. Neha Joshi"
//             style={INP}
//           />
//         </div>
//         <div>
//           <label style={LBL}>Specialty *</label>
//           <select
//             value={form.specialty}
//             onChange={(e) => sf("specialty", e.target.value)}
//             style={INP}
//           >
//             <option value="">— Select Specialty —</option>
//             {SPECIALTIES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <label style={LBL}>Doctor ID (Login Username) *</label>
//           <input
//             value={form.doctorId}
//             onChange={(e) => sf("doctorId", e.target.value.replace(/\s/g, ""))}
//             placeholder="e.g. drneha"
//             style={{ ...INP, fontFamily: "monospace", letterSpacing: "0.5px" }}
//           />
//           <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4 }}>
//             No spaces. Doctor types this at login screen.
//           </div>
//         </div>
//         <div>
//           <label style={LBL}>Password *</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showPw ? "text" : "password"}
//               value={form.password}
//               onChange={(e) => sf("password", e.target.value)}
//               placeholder="Min. 6 characters"
//               style={{ ...INP, paddingRight: 40 }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowPw((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showPw ? "🙈" : "👁️"}
//             </button>
//           </div>
//           {form.password && (
//             <div style={{ marginTop: 6 }}>
//               <div
//                 style={{
//                   height: 4,
//                   borderRadius: 2,
//                   background: "#e5e7eb",
//                   overflow: "hidden",
//                 }}
//               >
//                 <div
//                   style={{
//                     height: "100%",
//                     borderRadius: 2,
//                     width: `${(strength.score / 4) * 100}%`,
//                     background: strength.color,
//                     transition: "width 0.3s ease",
//                   }}
//                 />
//               </div>
//               <div
//                 style={{
//                   fontSize: 10,
//                   color: strength.color,
//                   fontWeight: 700,
//                   marginTop: 3,
//                 }}
//               >
//                 {strength.label}
//               </div>
//             </div>
//           )}
//         </div>
//         <div>
//           <label style={LBL}>Confirm Password *</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showCpw ? "text" : "password"}
//               value={form.confirmPw}
//               onChange={(e) => sf("confirmPw", e.target.value)}
//               placeholder="Re-enter password"
//               style={{
//                 ...INP,
//                 paddingRight: 40,
//                 borderColor:
//                   form.confirmPw && form.password !== form.confirmPw
//                     ? "#ef4444"
//                     : form.confirmPw && form.password === form.confirmPw
//                       ? "#22c55e"
//                       : "#d1d5db",
//               }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowCpw((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showCpw ? "🙈" : "👁️"}
//             </button>
//           </div>
//           {form.confirmPw && (
//             <div
//               style={{
//                 fontSize: 10,
//                 marginTop: 3,
//                 fontWeight: 700,
//                 color: form.password === form.confirmPw ? "#22c55e" : "#ef4444",
//               }}
//             >
//               {form.password === form.confirmPw
//                 ? "✓ Passwords match"
//                 : "✗ Passwords do not match"}
//             </div>
//           )}
//         </div>
//         <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//           <div style={{ flex: "1 1 140px" }}>
//             <button
//               onClick={handleCreate}
//               disabled={saving}
//               style={{ ...BTN_PRIMARY, opacity: saving ? 0.7 : 1 }}
//             >
//               {saving ? "Creating..." : "🔐 Create Account"}
//             </button>
//           </div>
//           <div style={{ flex: "1 1 100px" }}>
//             <button
//               onClick={() =>
//                 setForm({
//                   name: "",
//                   specialty: "",
//                   doctorId: "",
//                   password: "",
//                   confirmPw: "",
//                 })
//               }
//               style={BTN_GHOST}
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ChangePasswordForm({ currentDoctor, showNotify }) {
//   const [form, setForm] = useState({ oldPw: "", newPw: "", confirmPw: "" });
//   const [saving, setSaving] = useState(false);
//   const [showOld, setShowOld] = useState(false);
//   const [showNew, setShowNew] = useState(false);
//   const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const strength = passwordStrength(form.newPw);

//   const handleChange = async () => {
//     if (!form.oldPw) {
//       showNotify("Error", "Enter your current password.", true);
//       return;
//     }
//     if (!form.newPw) {
//       showNotify("Error", "Enter a new password.", true);
//       return;
//     }
//     if (form.newPw.length < 6) {
//       showNotify("Error", "New password must be at least 6 characters.", true);
//       return;
//     }
//     if (form.newPw !== form.confirmPw) {
//       showNotify("Error", "New passwords do not match.", true);
//       return;
//     }
//     if (form.oldPw === form.newPw) {
//       showNotify("Error", "New password must be different.", true);
//       return;
//     }
//     setSaving(true);
//     try {
//       await api.post("/auth/change-password", {
//         oldPassword: form.oldPw,
//         newPassword: form.newPw,
//       });
//       showNotify(
//         "Password Changed! ✓",
//         "Your new password is active. Use it next time you log in.",
//       );
//       setForm({ oldPw: "", newPw: "", confirmPw: "" });
//     } catch (err) {
//       showNotify("Error", err.message || "Failed to change password.", true);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 16,
//         padding: "20px",
//         boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
//       }}
//     >
//       <div
//         style={{
//           fontSize: 14,
//           fontWeight: 800,
//           color: "#0a1628",
//           marginBottom: 4,
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//         }}
//       >
//         <span
//           style={{
//             background: "linear-gradient(135deg,#92400e,#c9a84c)",
//             color: "#fff",
//             borderRadius: 8,
//             padding: "6px 10px",
//             fontSize: 16,
//           }}
//         >
//           🔑
//         </span>
//         Change My Password
//       </div>
//       <div
//         style={{
//           fontSize: 11,
//           color: "#64748b",
//           fontWeight: 500,
//           background: "#f1f5f9",
//           border: "1px solid #e2e8f0",
//           borderRadius: 8,
//           padding: "6px 12px",
//           marginBottom: 16,
//           display: "inline-block",
//         }}
//       >
//         Logged in as: <strong>{currentDoctor?.name}</strong>
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//         <div>
//           <label style={LBL}>Current Password</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showOld ? "text" : "password"}
//               value={form.oldPw}
//               onChange={(e) => sf("oldPw", e.target.value)}
//               placeholder="Your current password"
//               style={{ ...INP, paddingRight: 40 }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowOld((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showOld ? "🙈" : "👁️"}
//             </button>
//           </div>
//         </div>
//         <div>
//           <label style={LBL}>New Password</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type={showNew ? "text" : "password"}
//               value={form.newPw}
//               onChange={(e) => sf("newPw", e.target.value)}
//               placeholder="Min. 6 characters"
//               style={{ ...INP, paddingRight: 40 }}
//             />
//             <button
//               type="button"
//               onClick={() => setShowNew((p) => !p)}
//               style={{
//                 position: "absolute",
//                 right: 10,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 color: "#94a3b8",
//               }}
//             >
//               {showNew ? "🙈" : "👁️"}
//             </button>
//           </div>
//           {form.newPw && (
//             <div style={{ marginTop: 4 }}>
//               <div
//                 style={{
//                   height: 3,
//                   borderRadius: 2,
//                   background: "#e5e7eb",
//                   overflow: "hidden",
//                 }}
//               >
//                 <div
//                   style={{
//                     height: "100%",
//                     borderRadius: 2,
//                     width: `${(strength.score / 4) * 100}%`,
//                     background: strength.color,
//                   }}
//                 />
//               </div>
//               <div
//                 style={{
//                   fontSize: 10,
//                   color: strength.color,
//                   fontWeight: 700,
//                   marginTop: 2,
//                 }}
//               >
//                 {strength.label}
//               </div>
//             </div>
//           )}
//         </div>
//         <div>
//           <label style={LBL}>Confirm New Password</label>
//           <input
//             type="password"
//             value={form.confirmPw}
//             onChange={(e) => sf("confirmPw", e.target.value)}
//             placeholder="Re-enter new password"
//             style={{
//               ...INP,
//               borderColor:
//                 form.confirmPw && form.newPw !== form.confirmPw
//                   ? "#ef4444"
//                   : form.confirmPw && form.newPw === form.confirmPw
//                     ? "#22c55e"
//                     : "#d1d5db",
//             }}
//           />
//           {form.confirmPw && (
//             <div
//               style={{
//                 fontSize: 10,
//                 marginTop: 3,
//                 fontWeight: 700,
//                 color: form.newPw === form.confirmPw ? "#22c55e" : "#ef4444",
//               }}
//             >
//               {form.newPw === form.confirmPw ? "✓ Match" : "✗ No match"}
//             </div>
//           )}
//         </div>
//         <button
//           onClick={handleChange}
//           disabled={saving}
//           style={{
//             ...BTN_PRIMARY,
//             background: "linear-gradient(135deg,#92400e,#c9a84c)",
//             opacity: saving ? 0.7 : 1,
//           }}
//         >
//           {saving ? "Saving..." : "🔑 Update Password"}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default function DoctorAccountTab({ showNotify, doctor }) {
//   const { hospital } = useHospital(); // ✅ Get plan from hospital context
//   const [doctors, setDoctors] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // ✅ Determine plan and limit
//   const planName = (hospital?.subscriptionPlan || "starter").toLowerCase();
//   const planLimit = PLAN_LIMITS[planName] ?? 3;

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const hospitalId = getHospitalIdFromToken();
//       const url = hospitalId
//         ? `/auth/doctors?hospitalId=${hospitalId}`
//         : `/auth/doctors`;
//       const data = await api.get(url);
//       const filtered = Array.isArray(data)
//         ? data.filter((d) => !d.isAdmin)
//         : [];
//       setDoctors(filtered);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, [showNotify]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const handleDelete = async (doc) => {
//     if (
//       !window.confirm(
//         `Delete account for ${doc.name}?\n\nThey will no longer be able to log in.`,
//       )
//     )
//       return;
//     try {
//       await api.delete("/auth/doctors/" + doc._id);
//       showNotify("Deleted", `${doc.name}'s account removed.`);
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   return (
//     <div style={{ paddingBottom: 48 }}>
//       <style>{`
//         .da-outer-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; align-items: start; }
//         .da-steps-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
//         @media (max-width: 768px) {
//           .da-outer-grid { grid-template-columns: 1fr !important; }
//           .da-steps-grid { grid-template-columns: 1fr !important; }
//         }
//       `}</style>
//       <div className="admin-section-title">Doctor Accounts</div>
//       <div className="admin-section-desc" style={{ marginBottom: 20 }}>
//         Each doctor can create their own login account here. Once created, they
//         can log in using their <strong>Doctor ID + Password</strong>.
//       </div>

//       {/* ✅ Plan info bar */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//           background: "#f8fafc",
//           border: "1px solid #e5e7eb",
//           borderRadius: 10,
//           padding: "10px 16px",
//           marginBottom: 20,
//           flexWrap: "wrap",
//         }}
//       >
//         <span style={{ fontSize: 13, color: "#64748b" }}>Your plan:</span>
//         <span
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             color: "#fff",
//             borderRadius: 20,
//             fontSize: 12,
//             fontWeight: 700,
//             padding: "3px 12px",
//           }}
//         >
//           {PLAN_NAMES[planName] || planName}
//         </span>
//         <span style={{ fontSize: 13, color: "#64748b" }}>
//           · {planLimit === Infinity ? "Unlimited" : planLimit} doctor
//           {planLimit !== 1 && planLimit !== Infinity ? "s" : ""} allowed
//         </span>
//         {planLimit !== Infinity && (
//           <span
//             style={{
//               marginLeft: "auto",
//               fontSize: 12,
//               fontWeight: 700,
//               color: doctors.length >= planLimit ? "#dc2626" : "#16a34a",
//             }}
//           >
//             {doctors.length} / {planLimit} used
//           </span>
//         )}
//       </div>

//       <div
//         style={{
//           background:
//             "linear-gradient(135deg,rgba(10,22,40,0.04),rgba(13,115,119,0.06))",
//           border: "1px solid rgba(13,115,119,0.2)",
//           borderRadius: 12,
//           padding: "14px 16px",
//           marginBottom: 20,
//         }}
//       >
//         <div className="da-steps-grid">
//           {[
//             {
//               icon: "1️⃣",
//               text: "Doctor fills in their name, specialty, Doctor ID and password below",
//             },
//             {
//               icon: "2️⃣",
//               text: 'Click "Create Account" — saved instantly to database',
//             },
//             {
//               icon: "3️⃣",
//               text: "Doctor goes to login screen → types their Doctor ID + password → access granted",
//             },
//             {
//               icon: "4️⃣",
//               text: "Their name now appears on all visits, bills, prescriptions automatically",
//             },
//           ].map((s) => (
//             <div
//               key={s.icon}
//               style={{ display: "flex", gap: 8, alignItems: "flex-start" }}
//             >
//               <span style={{ fontSize: 18, flexShrink: 0 }}>{s.icon}</span>
//               <span style={{ fontSize: 12, color: "#475569", lineHeight: 1.5 }}>
//                 {s.text}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="da-outer-grid">
//         <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
//           {/* ✅ Pass plan info to CreateAccountForm */}
//           <CreateAccountForm
//             onCreated={load}
//             showNotify={showNotify}
//             doctorCount={doctors.length}
//             planLimit={planLimit}
//             planName={planName}
//           />
//           <ChangePasswordForm currentDoctor={doctor} showNotify={showNotify} />
//         </div>
//         <div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 8,
//             }}
//           >
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#1e293b",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//               }}
//             >
//               <span
//                 style={{
//                   background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                   color: "#fff",
//                   borderRadius: 8,
//                   padding: "4px 10px",
//                   fontSize: 13,
//                   fontWeight: 800,
//                 }}
//               >
//                 {loading ? "..." : doctors.length}
//               </span>
//               Doctor{doctors.length !== 1 ? "s" : ""} in system
//             </div>
//             <button
//               onClick={load}
//               style={{
//                 padding: "7px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 background: "#f8fafc",
//                 color: "#374151",
//                 fontWeight: 600,
//                 fontSize: 12,
//                 cursor: "pointer",
//               }}
//             >
//               🔄 Refresh
//             </button>
//           </div>
//           {loading ? (
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: 32,
//                 color: "#94a3b8",
//                 fontSize: 13,
//               }}
//             >
//               Loading accounts...
//             </div>
//           ) : doctors.length === 0 ? (
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: 40,
//                 background: "#f8fafc",
//                 borderRadius: 14,
//                 color: "#94a3b8",
//                 fontSize: 13,
//                 border: "1px dashed #e2e8f0",
//               }}
//             >
//               No doctor accounts yet.
//               <br />
//               Create the first one using the form.
//             </div>
//           ) : (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {doctors.map((doc) => (
//                 <DoctorCard
//                   key={doc._id}
//                   doc={doc}
//                   onDelete={handleDelete}
//                   currentDoctorId={doctor?.doctorId}
//                 />
//               ))}
//             </div>
//           )}
//           {doctors.length > 0 && (
//             <div
//               style={{
//                 marginTop: 16,
//                 background: "rgba(234,179,8,0.07)",
//                 border: "1px solid rgba(234,179,8,0.3)",
//                 borderRadius: 10,
//                 padding: "12px 14px",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 11,
//                   color: "#92400e",
//                   fontWeight: 700,
//                   marginBottom: 4,
//                 }}
//               >
//                 🔒 Security Reminder
//               </div>
//               <div style={{ fontSize: 11, color: "#78350f", lineHeight: 1.7 }}>
//                 • Each doctor should keep their password private.
//                 <br />
//                 • To reset a doctor's password, delete their account and create
//                 a new one.
//                 <br />• You cannot see saved passwords — only the doctor knows
//                 theirs.
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

/////////////// specality code /////////////////

// ============================================================
// src/components/admin/DoctorAccountTab.js
// ✅ Uses hospitalId from JWT token to isolate doctor accounts
// ✅ Plan-based doctor limit (starter=3, pro=10, enterprise=unlimited)
// ============================================================
import React, { useState, useEffect, useCallback } from "react";
import api from "../../utils/api";
import { useHospital } from "../../context/HospitalContext";

const INP = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 13,
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "'DM Sans',sans-serif",
  background: "#fff",
};
const LBL = {
  display: "block",
  fontSize: 11,
  fontWeight: 700,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginBottom: 5,
};
const BTN_PRIMARY = {
  padding: "11px 24px",
  borderRadius: 8,
  border: "none",
  background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
  color: "#fff",
  fontWeight: 700,
  fontSize: 13,
  cursor: "pointer",
  fontFamily: "'DM Sans',sans-serif",
  width: "100%",
};
const BTN_GHOST = {
  padding: "11px 18px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  background: "#f8fafc",
  color: "#374151",
  fontWeight: 600,
  fontSize: 13,
  cursor: "pointer",
  fontFamily: "'DM Sans',sans-serif",
  width: "100%",
};

// ✅ Plan limits
const PLAN_LIMITS = {
  starter: 3,
  pro: 10,
  enterprise: Infinity,
};

// ✅ Plan display names
const PLAN_NAMES = {
  starter: "Starter",
  pro: "Pro",
  enterprise: "Enterprise",
};

// ✅ Upgrade plan suggestion
const UPGRADE_PLAN = {
  starter: "Pro (₹1,999/month) — up to 10 doctors",
  pro: "Enterprise (₹3,499/month) — unlimited doctors",
  enterprise: null,
};

// ✅ Specialties by hospital type
const SPECIALTIES_BY_TYPE = {
  dental: [
    "Chief Dental Surgeon",
    "Cosmetic & Aesthetic Dentist",
    "Orthodontics & Invisalign",
    "Root Canal Specialist",
    "Pediatric Dentist",
    "Oral & Maxillofacial Surgeon",
    "Periodontics Specialist",
    "Prosthodontics",
    "General Dentistry",
    "Dental Implant Specialist",
    "Other",
  ],
  ayurved: [
    "Ayurvedic Physician",
    "Panchakarma Specialist",
    "Nadi Pariksha Expert",
    "Rasayana & Rejuvenation",
    "Ayurvedic Dermatologist",
    "Kaya Chikitsa (General Medicine)",
    "Shalya Tantra (Surgery)",
    "Stree Roga & Prasuti (Gynecology)",
    "Bala Roga (Pediatrics)",
    "Manas Roga (Psychiatry)",
    "Yoga & Naturopathy",
    "Other",
  ],
  ortho: [
    "Orthopedic Surgeon",
    "Joint Replacement Specialist",
    "Spine Surgeon",
    "Sports Medicine Specialist",
    "Trauma & Fracture Specialist",
    "Pediatric Orthopedician",
    "Arthroscopy Specialist",
    "Physiotherapist",
    "Rheumatologist",
    "Pain Management Specialist",
    "Other",
  ],
  eye: [
    "Ophthalmologist",
    "LASIK & Refractive Surgeon",
    "Cataract Surgeon",
    "Glaucoma Specialist",
    "Retina Specialist",
    "Pediatric Ophthalmologist",
    "Cornea Specialist",
    "Oculoplasty Surgeon",
    "Neuro-Ophthalmologist",
    "Optometrist",
    "Other",
  ],
  cardiology: [
    "Cardiologist",
    "Interventional Cardiologist",
    "Cardiac Surgeon",
    "Electrophysiologist",
    "Pediatric Cardiologist",
    "Preventive Cardiologist",
    "Heart Failure Specialist",
    "Echocardiography Specialist",
    "Vascular Surgeon",
    "Cardiac Anesthesiologist",
    "Other",
  ],
  pediatric: [
    "Pediatrician",
    "Neonatologist",
    "Pediatric Surgeon",
    "Pediatric Neurologist",
    "Pediatric Cardiologist",
    "Pediatric Gastroenterologist",
    "Pediatric Pulmonologist",
    "Developmental Pediatrician",
    "Pediatric Endocrinologist",
    "Pediatric Immunologist",
    "Other",
  ],
  general: [
    "General Physician",
    "General Surgeon",
    "Internal Medicine Specialist",
    "Emergency Medicine Specialist",
    "Gynecologist & Obstetrician",
    "ENT Specialist",
    "Dermatologist",
    "Psychiatrist",
    "Anesthesiologist",
    "Radiologist",
    "Pathologist",
    "Other",
  ],
};

// ✅ Get hospitalId from current JWT token
function getHospitalIdFromToken() {
  try {
    const path = window.location.pathname;
    const match = path.match(/\/hospital\/([^/]+)/);
    const slug = match ? match[1] : null;
    const key = slug
      ? `pearlsmile_token_${slug}`
      : "pearlsmile_token_pearlsmile";
    const token = localStorage.getItem(key);
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.hospitalId || null;
  } catch {
    return null;
  }
}

function passwordStrength(pw) {
  if (!pw) return { score: 0, label: "", color: "#e5e7eb" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  if (pw.length >= 12) score++;
  const map = [
    { label: "Very Weak", color: "#ef4444" },
    { label: "Weak", color: "#f97316" },
    { label: "Fair", color: "#eab308" },
    { label: "Good", color: "#22c55e" },
    { label: "Strong", color: "#16a34a" },
  ];
  return { score, ...map[Math.min(score, 4)] };
}

function DoctorCard({ doc, onDelete, currentDoctorId }) {
  const isMe = doc.doctorId === currentDoctorId;
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 14,
        padding: "14px 16px",
        display: "flex",
        gap: 12,
        alignItems: "flex-start",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        borderLeft: isMe ? "4px solid #0d7377" : "1px solid #e5e7eb",
      }}
    >
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: "50%",
          flexShrink: 0,
          background: isMe
            ? "linear-gradient(135deg,#0d7377,#14a0a5)"
            : "linear-gradient(135deg,#1e40af,#3b82f6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 20,
          color: "#fff",
          fontWeight: 700,
        }}
      >
        {(doc.name || "?")
          .replace(/^Dr\.\s*/i, "")
          .charAt(0)
          .toUpperCase()}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontWeight: 700, fontSize: 14, color: "#0a1628" }}>
            {doc.name}
          </div>
          {isMe && (
            <span
              style={{
                background: "rgba(13,115,119,0.12)",
                border: "1px solid rgba(13,115,119,0.3)",
                color: "#0d7377",
                borderRadius: 20,
                fontSize: 10,
                fontWeight: 800,
                padding: "2px 8px",
                letterSpacing: "0.5px",
              }}
            >
              YOU
            </span>
          )}
        </div>
        <div
          style={{
            fontSize: 12,
            color: "#0d7377",
            fontWeight: 600,
            marginTop: 2,
          }}
        >
          {doc.specialty || "—"}
        </div>
        <div
          style={{
            marginTop: 6,
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <span
            style={{
              background: "#f1f5f9",
              border: "1px solid #e2e8f0",
              borderRadius: 6,
              fontSize: 11,
              padding: "3px 8px",
              color: "#475569",
              fontWeight: 600,
              fontFamily: "monospace",
            }}
          >
            ID: {doc.doctorId}
          </span>
          {doc.createdAt && (
            <span style={{ fontSize: 11, color: "#94a3b8" }}>
              Joined{" "}
              {new Date(doc.createdAt).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </span>
          )}
        </div>
      </div>
      {!isMe && (
        <button
          onClick={() => onDelete(doc)}
          style={{
            padding: "6px 12px",
            borderRadius: 7,
            border: "1px solid #fca5a5",
            background: "#fef2f2",
            color: "#dc2626",
            fontSize: 11,
            fontWeight: 700,
            cursor: "pointer",
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          Delete
        </button>
      )}
    </div>
  );
}

// ✅ Plan limit banner shown when limit is reached
function PlanLimitBanner({ planName, limit, upgradeTo }) {
  return (
    <div
      style={{
        background: "linear-gradient(135deg,#fef3c7,#fde68a)",
        border: "1.5px solid #f59e0b",
        borderRadius: 14,
        padding: "16px 18px",
        marginBottom: 16,
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
        <span style={{ fontSize: 28, flexShrink: 0 }}>🚫</span>
        <div>
          <div
            style={{
              fontWeight: 800,
              fontSize: 14,
              color: "#92400e",
              marginBottom: 4,
            }}
          >
            Doctor Limit Reached — {PLAN_NAMES[planName] || planName} Plan
          </div>
          <div
            style={{
              fontSize: 13,
              color: "#78350f",
              lineHeight: 1.6,
              marginBottom: 8,
            }}
          >
            Your <strong>{PLAN_NAMES[planName] || planName}</strong> plan allows
            a maximum of{" "}
            <strong>
              {limit} doctor{limit !== 1 ? "s" : ""}
            </strong>
            . You have already reached this limit and cannot add more doctors.
          </div>
          {upgradeTo && (
            <div
              style={{
                background: "rgba(255,255,255,0.7)",
                border: "1px solid rgba(245,158,11,0.4)",
                borderRadius: 8,
                padding: "10px 14px",
                fontSize: 12,
                color: "#92400e",
              }}
            >
              <span style={{ fontWeight: 700 }}>💡 Upgrade to </span>
              {upgradeTo}
              <br />
              <span style={{ color: "#78350f" }}>
                Contact your admin or go to the <strong>💳 Subscription</strong>{" "}
                tab to upgrade your plan.
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function CreateAccountForm({
  onCreated,
  showNotify,
  doctorCount,
  planLimit,
  planName,
  hospitalType,
}) {
  const [form, setForm] = useState({
    name: "",
    specialty: "",
    doctorId: "",
    password: "",
    confirmPw: "",
  });
  const [saving, setSaving] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const [showCpw, setShowCpw] = useState(false);
  const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const strength = passwordStrength(form.password);
  // ✅ Dynamic specialties based on hospital type
  const SPECIALTIES =
    SPECIALTIES_BY_TYPE[(hospitalType || "dental").toLowerCase()] ||
    SPECIALTIES_BY_TYPE.dental;

  // ✅ Check if limit reached
  const limitReached = planLimit !== Infinity && doctorCount >= planLimit;

  const handleCreate = async () => {
    // ✅ Plan limit check FIRST
    if (limitReached) {
      showNotify(
        "Plan Limit Reached 🚫",
        `Your ${PLAN_NAMES[planName] || planName} plan allows only ${planLimit} doctor${planLimit !== 1 ? "s" : ""}. Please upgrade your plan to add more doctors.`,
        true,
      );
      return;
    }
    if (!form.name.trim()) {
      showNotify("Error", "Full name is required.", true);
      return;
    }
    if (!form.specialty) {
      showNotify("Error", "Please select a specialty.", true);
      return;
    }
    if (!form.doctorId.trim()) {
      showNotify("Error", "Doctor ID is required.", true);
      return;
    }
    if (form.doctorId.includes(" ")) {
      showNotify("Error", "Doctor ID cannot contain spaces.", true);
      return;
    }
    if (!form.password) {
      showNotify("Error", "Password is required.", true);
      return;
    }
    if (form.password.length < 6) {
      showNotify("Error", "Password must be at least 6 characters.", true);
      return;
    }
    if (form.password !== form.confirmPw) {
      showNotify("Error", "Passwords do not match.", true);
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/register", {
        name: form.name.trim(),
        specialty: form.specialty,
        doctorId: form.doctorId.trim().toLowerCase(),
        password: form.password,
      });
      showNotify(
        "Account Created! ✓",
        `Dr. ${form.name} can now log in with ID: ${form.doctorId.toLowerCase()}`,
      );
      setForm({
        name: "",
        specialty: "",
        doctorId: "",
        password: "",
        confirmPw: "",
      });
      onCreated();
    } catch (err) {
      showNotify("Error", err.message || "Failed to create account.", true);
    }
    setSaving(false);
  };

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        padding: "20px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          fontSize: 14,
          fontWeight: 800,
          color: "#0a1628",
          marginBottom: 16,
          display: "flex",
          alignItems: "center",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <span
          style={{
            background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
            color: "#fff",
            borderRadius: 8,
            padding: "6px 10px",
            fontSize: 16,
          }}
        >
          🩺
        </span>
        Create New Doctor Account
        {/* ✅ Plan limit indicator */}
        {planLimit !== Infinity && (
          <span
            style={{
              marginLeft: "auto",
              background: limitReached ? "#fef2f2" : "#f0fdf4",
              border: `1px solid ${limitReached ? "#fca5a5" : "#bbf7d0"}`,
              color: limitReached ? "#dc2626" : "#16a34a",
              borderRadius: 20,
              fontSize: 11,
              fontWeight: 700,
              padding: "3px 10px",
            }}
          >
            {doctorCount} / {planLimit} doctors used
          </span>
        )}
      </div>

      {/* ✅ Show limit banner if reached */}
      {limitReached && (
        <PlanLimitBanner
          planName={planName}
          limit={planLimit}
          upgradeTo={UPGRADE_PLAN[planName]}
        />
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 14,
          opacity: limitReached ? 0.5 : 1,
          pointerEvents: limitReached ? "none" : "auto",
        }}
      >
        <div>
          <label style={LBL}>Full Name *</label>
          <input
            value={form.name}
            onChange={(e) => sf("name", e.target.value)}
            placeholder="e.g. Dr. Neha Joshi"
            style={INP}
          />
        </div>
        <div>
          <label style={LBL}>Specialty *</label>
          <select
            value={form.specialty}
            onChange={(e) => sf("specialty", e.target.value)}
            style={INP}
          >
            <option value="">— Select Specialty —</option>
            {SPECIALTIES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label style={LBL}>Doctor ID (Login Username) *</label>
          <input
            value={form.doctorId}
            onChange={(e) => sf("doctorId", e.target.value.replace(/\s/g, ""))}
            placeholder="e.g. drneha"
            style={{ ...INP, fontFamily: "monospace", letterSpacing: "0.5px" }}
          />
          <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4 }}>
            No spaces. Doctor types this at login screen.
          </div>
        </div>
        <div>
          <label style={LBL}>Password *</label>
          <div style={{ position: "relative" }}>
            <input
              type={showPw ? "text" : "password"}
              value={form.password}
              onChange={(e) => sf("password", e.target.value)}
              placeholder="Min. 6 characters"
              style={{ ...INP, paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setShowPw((p) => !p)}
              style={{
                position: "absolute",
                right: 10,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: 14,
                color: "#94a3b8",
              }}
            >
              {showPw ? "🙈" : "👁️"}
            </button>
          </div>
          {form.password && (
            <div style={{ marginTop: 6 }}>
              <div
                style={{
                  height: 4,
                  borderRadius: 2,
                  background: "#e5e7eb",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    borderRadius: 2,
                    width: `${(strength.score / 4) * 100}%`,
                    background: strength.color,
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 10,
                  color: strength.color,
                  fontWeight: 700,
                  marginTop: 3,
                }}
              >
                {strength.label}
              </div>
            </div>
          )}
        </div>
        <div>
          <label style={LBL}>Confirm Password *</label>
          <div style={{ position: "relative" }}>
            <input
              type={showCpw ? "text" : "password"}
              value={form.confirmPw}
              onChange={(e) => sf("confirmPw", e.target.value)}
              placeholder="Re-enter password"
              style={{
                ...INP,
                paddingRight: 40,
                borderColor:
                  form.confirmPw && form.password !== form.confirmPw
                    ? "#ef4444"
                    : form.confirmPw && form.password === form.confirmPw
                      ? "#22c55e"
                      : "#d1d5db",
              }}
            />
            <button
              type="button"
              onClick={() => setShowCpw((p) => !p)}
              style={{
                position: "absolute",
                right: 10,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: 14,
                color: "#94a3b8",
              }}
            >
              {showCpw ? "🙈" : "👁️"}
            </button>
          </div>
          {form.confirmPw && (
            <div
              style={{
                fontSize: 10,
                marginTop: 3,
                fontWeight: 700,
                color: form.password === form.confirmPw ? "#22c55e" : "#ef4444",
              }}
            >
              {form.password === form.confirmPw
                ? "✓ Passwords match"
                : "✗ Passwords do not match"}
            </div>
          )}
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 140px" }}>
            <button
              onClick={handleCreate}
              disabled={saving}
              style={{ ...BTN_PRIMARY, opacity: saving ? 0.7 : 1 }}
            >
              {saving ? "Creating..." : "🔐 Create Account"}
            </button>
          </div>
          <div style={{ flex: "1 1 100px" }}>
            <button
              onClick={() =>
                setForm({
                  name: "",
                  specialty: "",
                  doctorId: "",
                  password: "",
                  confirmPw: "",
                })
              }
              style={BTN_GHOST}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ChangePasswordForm({ currentDoctor, showNotify }) {
  const [form, setForm] = useState({ oldPw: "", newPw: "", confirmPw: "" });
  const [saving, setSaving] = useState(false);
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const strength = passwordStrength(form.newPw);

  const handleChange = async () => {
    if (!form.oldPw) {
      showNotify("Error", "Enter your current password.", true);
      return;
    }
    if (!form.newPw) {
      showNotify("Error", "Enter a new password.", true);
      return;
    }
    if (form.newPw.length < 6) {
      showNotify("Error", "New password must be at least 6 characters.", true);
      return;
    }
    if (form.newPw !== form.confirmPw) {
      showNotify("Error", "New passwords do not match.", true);
      return;
    }
    if (form.oldPw === form.newPw) {
      showNotify("Error", "New password must be different.", true);
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        oldPassword: form.oldPw,
        newPassword: form.newPw,
      });
      showNotify(
        "Password Changed! ✓",
        "Your new password is active. Use it next time you log in.",
      );
      setForm({ oldPw: "", newPw: "", confirmPw: "" });
    } catch (err) {
      showNotify("Error", err.message || "Failed to change password.", true);
    }
    setSaving(false);
  };

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        padding: "20px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          fontSize: 14,
          fontWeight: 800,
          color: "#0a1628",
          marginBottom: 4,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span
          style={{
            background: "linear-gradient(135deg,#92400e,#c9a84c)",
            color: "#fff",
            borderRadius: 8,
            padding: "6px 10px",
            fontSize: 16,
          }}
        >
          🔑
        </span>
        Change My Password
      </div>
      <div
        style={{
          fontSize: 11,
          color: "#64748b",
          fontWeight: 500,
          background: "#f1f5f9",
          border: "1px solid #e2e8f0",
          borderRadius: 8,
          padding: "6px 12px",
          marginBottom: 16,
          display: "inline-block",
        }}
      >
        Logged in as: <strong>{currentDoctor?.name}</strong>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <div>
          <label style={LBL}>Current Password</label>
          <div style={{ position: "relative" }}>
            <input
              type={showOld ? "text" : "password"}
              value={form.oldPw}
              onChange={(e) => sf("oldPw", e.target.value)}
              placeholder="Your current password"
              style={{ ...INP, paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setShowOld((p) => !p)}
              style={{
                position: "absolute",
                right: 10,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: 14,
                color: "#94a3b8",
              }}
            >
              {showOld ? "🙈" : "👁️"}
            </button>
          </div>
        </div>
        <div>
          <label style={LBL}>New Password</label>
          <div style={{ position: "relative" }}>
            <input
              type={showNew ? "text" : "password"}
              value={form.newPw}
              onChange={(e) => sf("newPw", e.target.value)}
              placeholder="Min. 6 characters"
              style={{ ...INP, paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setShowNew((p) => !p)}
              style={{
                position: "absolute",
                right: 10,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: 14,
                color: "#94a3b8",
              }}
            >
              {showNew ? "🙈" : "👁️"}
            </button>
          </div>
          {form.newPw && (
            <div style={{ marginTop: 4 }}>
              <div
                style={{
                  height: 3,
                  borderRadius: 2,
                  background: "#e5e7eb",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    borderRadius: 2,
                    width: `${(strength.score / 4) * 100}%`,
                    background: strength.color,
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 10,
                  color: strength.color,
                  fontWeight: 700,
                  marginTop: 2,
                }}
              >
                {strength.label}
              </div>
            </div>
          )}
        </div>
        <div>
          <label style={LBL}>Confirm New Password</label>
          <input
            type="password"
            value={form.confirmPw}
            onChange={(e) => sf("confirmPw", e.target.value)}
            placeholder="Re-enter new password"
            style={{
              ...INP,
              borderColor:
                form.confirmPw && form.newPw !== form.confirmPw
                  ? "#ef4444"
                  : form.confirmPw && form.newPw === form.confirmPw
                    ? "#22c55e"
                    : "#d1d5db",
            }}
          />
          {form.confirmPw && (
            <div
              style={{
                fontSize: 10,
                marginTop: 3,
                fontWeight: 700,
                color: form.newPw === form.confirmPw ? "#22c55e" : "#ef4444",
              }}
            >
              {form.newPw === form.confirmPw ? "✓ Match" : "✗ No match"}
            </div>
          )}
        </div>
        <button
          onClick={handleChange}
          disabled={saving}
          style={{
            ...BTN_PRIMARY,
            background: "linear-gradient(135deg,#92400e,#c9a84c)",
            opacity: saving ? 0.7 : 1,
          }}
        >
          {saving ? "Saving..." : "🔑 Update Password"}
        </button>
      </div>
    </div>
  );
}

export default function DoctorAccountTab({ showNotify, doctor }) {
  const { hospital } = useHospital(); // ✅ Get plan from hospital context
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Determine plan and limit
  const planName = (hospital?.subscriptionPlan || "starter").toLowerCase();
  const planLimit = PLAN_LIMITS[planName] ?? 3;

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const hospitalId = getHospitalIdFromToken();
      const url = hospitalId
        ? `/auth/doctors?hospitalId=${hospitalId}`
        : `/auth/doctors`;
      const data = await api.get(url);
      const filtered = Array.isArray(data)
        ? data.filter((d) => !d.isAdmin)
        : [];
      setDoctors(filtered);
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setLoading(false);
  }, [showNotify]);

  useEffect(() => {
    load();
  }, [load]);

  const handleDelete = async (doc) => {
    if (
      !window.confirm(
        `Delete account for ${doc.name}?\n\nThey will no longer be able to log in.`,
      )
    )
      return;
    try {
      await api.delete("/auth/doctors/" + doc._id);
      showNotify("Deleted", `${doc.name}'s account removed.`);
      load();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  return (
    <div style={{ paddingBottom: 48 }}>
      <style>{`
        .da-outer-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; align-items: start; }
        .da-steps-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
        @media (max-width: 768px) {
          .da-outer-grid { grid-template-columns: 1fr !important; }
          .da-steps-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
      <div className="admin-section-title">Doctor Accounts</div>
      <div className="admin-section-desc" style={{ marginBottom: 20 }}>
        Each doctor can create their own login account here. Once created, they
        can log in using their <strong>Doctor ID + Password</strong>.
      </div>

      {/* ✅ Plan info bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          background: "#f8fafc",
          border: "1px solid #e5e7eb",
          borderRadius: 10,
          padding: "10px 16px",
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >
        <span style={{ fontSize: 13, color: "#64748b" }}>Your plan:</span>
        <span
          style={{
            background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
            color: "#fff",
            borderRadius: 20,
            fontSize: 12,
            fontWeight: 700,
            padding: "3px 12px",
          }}
        >
          {PLAN_NAMES[planName] || planName}
        </span>
        <span style={{ fontSize: 13, color: "#64748b" }}>
          · {planLimit === Infinity ? "Unlimited" : planLimit} doctor
          {planLimit !== 1 && planLimit !== Infinity ? "s" : ""} allowed
        </span>
        {planLimit !== Infinity && (
          <span
            style={{
              marginLeft: "auto",
              fontSize: 12,
              fontWeight: 700,
              color: doctors.length >= planLimit ? "#dc2626" : "#16a34a",
            }}
          >
            {doctors.length} / {planLimit} used
          </span>
        )}
      </div>

      <div
        style={{
          background:
            "linear-gradient(135deg,rgba(10,22,40,0.04),rgba(13,115,119,0.06))",
          border: "1px solid rgba(13,115,119,0.2)",
          borderRadius: 12,
          padding: "14px 16px",
          marginBottom: 20,
        }}
      >
        <div className="da-steps-grid">
          {[
            {
              icon: "1️⃣",
              text: "Doctor fills in their name, specialty, Doctor ID and password below",
            },
            {
              icon: "2️⃣",
              text: 'Click "Create Account" — saved instantly to database',
            },
            {
              icon: "3️⃣",
              text: "Doctor goes to login screen → types their Doctor ID + password → access granted",
            },
            {
              icon: "4️⃣",
              text: "Their name now appears on all visits, bills, prescriptions automatically",
            },
          ].map((s) => (
            <div
              key={s.icon}
              style={{ display: "flex", gap: 8, alignItems: "flex-start" }}
            >
              <span style={{ fontSize: 18, flexShrink: 0 }}>{s.icon}</span>
              <span style={{ fontSize: 12, color: "#475569", lineHeight: 1.5 }}>
                {s.text}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="da-outer-grid">
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {/* ✅ Pass plan info to CreateAccountForm */}
          <CreateAccountForm
            onCreated={load}
            showNotify={showNotify}
            doctorCount={doctors.length}
            planLimit={planLimit}
            planName={planName}
            hospitalType={hospital?.type}
          />
          <ChangePasswordForm currentDoctor={doctor} showNotify={showNotify} />
        </div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 14,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#1e293b",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span
                style={{
                  background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                  color: "#fff",
                  borderRadius: 8,
                  padding: "4px 10px",
                  fontSize: 13,
                  fontWeight: 800,
                }}
              >
                {loading ? "..." : doctors.length}
              </span>
              Doctor{doctors.length !== 1 ? "s" : ""} in system
            </div>
            <button
              onClick={load}
              style={{
                padding: "7px 14px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                background: "#f8fafc",
                color: "#374151",
                fontWeight: 600,
                fontSize: 12,
                cursor: "pointer",
              }}
            >
              🔄 Refresh
            </button>
          </div>
          {loading ? (
            <div
              style={{
                textAlign: "center",
                padding: 32,
                color: "#94a3b8",
                fontSize: 13,
              }}
            >
              Loading accounts...
            </div>
          ) : doctors.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: 40,
                background: "#f8fafc",
                borderRadius: 14,
                color: "#94a3b8",
                fontSize: 13,
                border: "1px dashed #e2e8f0",
              }}
            >
              No doctor accounts yet.
              <br />
              Create the first one using the form.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {doctors.map((doc) => (
                <DoctorCard
                  key={doc._id}
                  doc={doc}
                  onDelete={handleDelete}
                  currentDoctorId={doctor?.doctorId}
                />
              ))}
            </div>
          )}
          {doctors.length > 0 && (
            <div
              style={{
                marginTop: 16,
                background: "rgba(234,179,8,0.07)",
                border: "1px solid rgba(234,179,8,0.3)",
                borderRadius: 10,
                padding: "12px 14px",
              }}
            >
              <div
                style={{
                  fontSize: 11,
                  color: "#92400e",
                  fontWeight: 700,
                  marginBottom: 4,
                }}
              >
                🔒 Security Reminder
              </div>
              <div style={{ fontSize: 11, color: "#78350f", lineHeight: 1.7 }}>
                • Each doctor should keep their password private.
                <br />
                • To reset a doctor's password, delete their account and create
                a new one.
                <br />• You cannot see saved passwords — only the doctor knows
                theirs.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
